export default __webpack_public_path__ + "static/media/user.ab0b0bb1.svg";